
// reworked from https://codesandbox.io/s/wheel-of-prize-forked-zikutr

import {
	calculateSpinningWheelSize,
} from './wheelSize';
import { draw, drawOuterRim, drawWheel } from './paint';
import { segmentsColors } from './styles';
import { calculateOptimalFontSizeForLabel, trimNameForLabel } from './labels';
import { runAnimation } from './runAnimation';

export const setupSpinningWheel = (canvases, prizes, onFinish, onShowWinner) => {

	const {
		mainCanvas: canvas,
		wheelCanvas,
		outerRimCanvas,
	} = canvases;
	const canvasContext = canvas.getContext('2d');

	const { size, center, radius } = calculateSpinningWheelSize();

	canvas.setAttribute('width', size);
	canvas.setAttribute('height', size);

	wheelCanvas.setAttribute('width', size);
	wheelCanvas.setAttribute('height', size);

	outerRimCanvas.setAttribute('width', size);
	outerRimCanvas.setAttribute('height', size);

	const settings = {
		center,
		radius,
		segments: prizes.map((segment, i) => ({
			...segment,
			color:
				i === prizes.length - 1 && i % segmentsColors.length === 0
					? segmentsColors[1]
					: segmentsColors[i % segmentsColors.length],
			name: trimNameForLabel(segment.name),
			fontSize: calculateOptimalFontSizeForLabel(
				segment.name,
				prizes.length,
				radius,
				canvasContext
			),
		})),
		onFinish,
		onShowWinner,
	};

	const wheelCanvasContext = wheelCanvas.getContext('2d');

	drawWheel(wheelCanvasContext, settings);

	const outerRimCanvasContext = outerRimCanvas.getContext('2d');

	drawOuterRim(outerRimCanvasContext, settings);

	const state = {
		angle: 0,
		dismissed: false,
	};

	const paint = () => {
		draw(canvasContext, wheelCanvas, outerRimCanvas, state, settings);
	};

	paint();

	const run = (totalAngle) =>
		runAnimation(paint, state, settings, totalAngle);

	return {
		run,
		dismiss: () => {
			state.dismissed = true;
		}
	};
};

